import React from 'react';
import { useSelector } from 'react-redux';
import { HOST, TENANTS_NAMES } from 'tenant/host_config';
import useNewTicketNotifications from './useNewTicketNotifications';

const NewTicketNotificationsConsumer = () => {
  useNewTicketNotifications();
  return <></>;
};

const NewTicketnotifications = () => {
  const me = useSelector((state) => state.me);
  const isLoggedIn = me?.id !== null && me?.id !== undefined;
  const isNewTicketNotificationsEnabled = isLoggedIn && HOST === TENANTS_NAMES.xpo;
  if (isNewTicketNotificationsEnabled) {
    return <NewTicketNotificationsConsumer />;
  }
  return <></>;
};

export default NewTicketnotifications;
